export const reviewDataFromService = (data) => ({
    averageRating: data.average_rating ?? null,
    totalReviews: data.total_reviews ?? null,
    reviews: data.reviews ?? [],
    sources: data.sources ?? []
});
//# sourceMappingURL=reviews.js.map